import React from 'react';

export const KeyboardHints: React.FC = () => (
  <div
    className="flex items-center justify-center gap-4 mt-6 text-xs"
    style={{ color: 'var(--rush-text-muted)', opacity: 0.6 }}
  >
    <span>
      <kbd className="inline-block px-1.5 py-0.5 rounded border text-[10px] font-mono mr-1" style={{ borderColor: 'var(--rush-border)' }}>←</kbd>
      Left
    </span>
    <span>
      <kbd className="inline-block px-1.5 py-0.5 rounded border text-[10px] font-mono mr-1" style={{ borderColor: 'var(--rush-border)' }}>→</kbd>
      Right
    </span>
    <span>
      <kbd className="inline-block px-1.5 py-0.5 rounded border text-[10px] font-mono mr-1" style={{ borderColor: 'var(--rush-border)' }}>Enter</kbd>
      Submit
    </span>
  </div>
);
